import { Button, DatePicker, Form, Input,  Table } from "antd"
import { searchAssistance } from "../../api"
import {  PageBuilder } from "../../utils/Page"
import { useEffect, useState } from "react"
import '../matchResult/index.css'
import { AssistanceSearchFilter, AssistanceView } from "../../interfaces/Assistance"
import { format } from 'date-fns';

const Assistance = () => {
    const [searchFilter, setSearchFilter] = useState<AssistanceSearchFilter>({})
    const [data, setData] = useState<AssistanceView[]>()
    const [current, setCurrent] = useState<number>(1)
    const [pageSize, setPageSize] = useState<number>(10)
    const [totalElements, setTotalElements] = useState<number>(500)
    const columns = [
        {
            title: "捐助订单 id",
            dataIndex: "donationApplicationId",
        },
        {
            title: "用户编号",
            dataIndex: "userNumber",
        },
        {
            title: "申请时间",
            dataIndex: "applicationTime",
           render: (time?: Date) => time?format(time, 'yyyy-MM-dd'):''
        },
        {
            title: "匹配时间",
            dataIndex: "matchTime",
           render: (time?: Date) => time?format(time, 'yyyy-MM-dd'):''
        },
        {
            title: "金额",
            dataIndex: "amount",
        },
        {
            title: "积分",
            dataIndex: "point",
        },
    ]

    const search = async () => {
        const page = new PageBuilder()
            .setPage(current - 1)
            .setSize(pageSize)
            .build()
        const { data } = await searchAssistance({
            params: { ...page, searchFilterCombineOperation: "AND" },
            filters: searchFilter
        })
        setData(data.content)
        setTotalElements(data.totalElements)
    }

    const handleSearch = async (filter: AssistanceSearchFilter) => {
        setSearchFilter(filter)
    }

    const handleTableChange = (pagination: any) => {
        setCurrent(pagination.current)
        setPageSize(pagination.pageSize)
    }

    useEffect(() => { search() }, [current, pageSize, searchFilter])
    return <div>
        <div className="flex-box">
            <Form<AssistanceSearchFilter>
                layout="inline"
                onFinish={handleSearch}
            >
                <Form.Item 
                label="手机号: "
                name="phoneNumberLike">
                    <Input />
                </Form.Item>
              <Form.Item
                label="申请开始时间: "
                name="applicationTimeAfter">
                <DatePicker />
              </Form.Item>
                <Form.Item
                    label="申请结束时间: "
                    name="applicationTimeBefore"
                    >
                <DatePicker />
                </Form.Item>
                <Form.Item
                label="匹配开始时间: "
                name="matchTimeAfter">
                <DatePicker />
              </Form.Item>
                <Form.Item
                    label="匹配结束时间: "
                    name="matchTimeBefore"
                    >
                <DatePicker />
                </Form.Item>
                <Form.Item
                    label="金额: "
                    name="amount"
                    >
                    <Input type="number"/>
                </Form.Item>
                <div className="search-button">
                <Form.Item>
                    <Button htmlType="reset" type="default">重置</Button>
                </Form.Item>
                <Form.Item>
                    <Button htmlType="submit" type="primary">搜索</Button>
                </Form.Item>
                </div>
            </Form>
        </div>

        <Table<AssistanceView> rowKey={'id'} columns={columns} dataSource={data}
            pagination={{
                current: current,
                total: totalElements,
                hideOnSinglePage: true
            }}
            onChange={handleTableChange}
        />
    </div>
}

export default Assistance
